<template>
  <v-container
    fill-height
    fluid
    class="container"
    :style="{
      backgroundImage: `url('static/img/wallpapers/wp${1 + Math.floor(Math.random() * 7)}.jpg')`,
    }"
  >
    <div class="overlay" style="z-index: 1000">
      <v-layout align-center justify-center>
        <router-view />
      </v-layout>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "out",
  data: function () {
    return {
      backgroundImage: "",
    };
  },
  mounted: function () {
    this.backgroundImage = {};
  },
};
</script>

<style scoped>
.container {
  padding: 0;

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.overlay {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);

  display: flex;
}

@-webkit-keyframes bg-pan-left {
  0% {
    /*background: rgba(74, 151, 206, 1);*/
    background-position: 100% 50%;
  }
  100% {
    /*background: rgba(95, 191, 141, 1);*/
    background-position: 0% 50%;
  }
}

@keyframes bg-pan-left {
  0% {
    /*background: rgba(74, 151, 206, 1);*/
    background-position: 100% 50%;
  }
  100% {
    /*background: rgba(95, 191, 141, 1);*/
    background-position: 0% 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Out.vue